import React, { useState } from "react";

import Header from "../components/Header";
import AppCard from "../components/AppCard";
import StatCard from "../components/StatCard";
import trendIcon from "../assets/res/trend_icon.svg";
import modsIcon from "../assets/res/star_mod_icon.svg";
import timeIcon from "../assets/res/time_icon.svg";
import { formatCount, formatCompact } from "../utils/Helpers";

const GamesPage = ({ handleItemClick, numbers }) => {
  const [query, setQuery] = useState("");

  function querySearched(q) {
    setQuery(q);
  }

  const searchTerm = query.trim().toLowerCase();
  const hasQuery = searchTerm.length > 0;

  const filteredItems = hasQuery
    ? numbers.filter((item) =>
        String(item.name).toLowerCase().includes(searchTerm)
      )
    : numbers.slice(0, 20).reverse();

  const modsValue = 300 + numbers.length;

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-[#fff1f1] via-[#fff7f6] to-white drop-shadow lg:mx-auto lg:w-[500px] lg:border-[1px] lg:border-gray-200">
      {/* soft brand glow behind the header */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[260px] bg-[radial-gradient(120%_80%_at_50%_-20%,rgba(213,4,4,0.16),transparent_70%)]" />

      <div className="relative">
        <Header querySearched={querySearched} />

        {!hasQuery && (
          <div className="flex gap-[12px] px-[16px] pt-[16px]">
            <StatCard
              icon={trendIcon}
              value={1200000}
              format={formatCompact}
              suffix="+"
              label={"Downloads"}
            />
            <StatCard
              icon={modsIcon}
              value={modsValue}
              format={formatCount}
              suffix="+"
              label={"Mods"}
            />
            <StatCard icon={timeIcon} value={"Daily"} label={"Updates"} />
          </div>
        )}

        {/* section header */}
        <div className="flex items-center gap-[10px] px-[20px] pt-[22px] pb-[2px]">
          <span className="h-[18px] w-[4px] rounded-full bg-primary" />
          <h2 className="semiBold text-2xl leading-none text-dark">
            {hasQuery ? "Search results" : "Trending now"}
          </h2>
        </div>

        <div className="space-y-[12px] pb-[28px] pt-[12px]">
          {filteredItems.length > 0 ? (
            filteredItems.map((app, index) => (
              <div
                key={index}
                className="fade-up"
                style={{ animationDelay: `${Math.min(index, 10) * 55}ms` }}
              >
                <AppCard app={app} onGameClicked={() => handleItemClick(app)} />
              </div>
            ))
          ) : (
            <div className="mx-4 mt-6 flex flex-col items-center rounded-2xl border border-dashed border-gray-300 bg-white/70 px-6 py-12 text-center">
              <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primaryLight/40">
                <img src={modsIcon} alt="" className="h-6 w-6 opacity-70" />
              </div>
              <p className="semiBold text-xl text-dark">No matches found</p>
              <p className="medium text-sm text-gray-500">
                Try a different game, app or mod name.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GamesPage;
